<template>
  <div>
    <a-card :bordered="false" class="header-solid h-full">
      <template #title>
        <a-row type="flex" align="middle" style="margin-bottom: 10px">
          <a-col :span="8" :md="8">
            <a-button
              type="primary"
              icon="arrow-down"
              size="small"
              style="margin-right: 10px"
              @click="GrabBySearch()"
              v-show="false"
              v-if="isAdmin"
            >
              按照条件抓取指数
            </a-button>

            <a-button
              type="primary"
              icon="check"
              size="small"
              style="margin-right: 10px"
              @click="GrabAllKeys()"
              v-if="isAdmin"
            >
              全部抓取指数
            </a-button>

            <a-button
              type="danger"
              icon="delete"
              size="small"
              @click="DelAllKeys()"
              v-if="isAdmin"
            >
              清空指数任务
            </a-button>
          </a-col>

          <a-col
            :span="16"
            :md="16"
            style="
              display: flex;
              align-items: center;
              justify-content: flex-end;
            "
          >
            <a-input
              v-model="Query.skey"
              placeholder="关键词"
              size="small"
              style="width: 150px; margin-right: 10px"
            />
            <a-button
              type="primary"
              icon="search"
              size="small"
              style="margin-right: 10px"
              @click="GetTableData()"
            >
              查询
            </a-button>
          </a-col>
        </a-row>
        <a-row type="flex" align="middle" style="margin-bottom: 10px">
          <a-col :span="12" :md="12"> </a-col>
          <a-col
            :span="12"
            :md="12"
            style="
              display: flex;
              align-items: center;
              justify-content: flex-end;
            "
          >
          </a-col>
        </a-row>

        <a-row type="flex" align="top" :gutter="16">
          <a-col :span="24">
            <el-table
              size="medium"
              :data="tableData"
              :stripe="true"
              @sort-change="sortChange"
              style="width: 100%; border: 1px solid #e4e7ed"
            >
              <el-table-column prop="etfName" label="名称"> </el-table-column>
              <el-table-column prop="etfDm" label="代码"> </el-table-column>
              <el-table-column
                prop="lastWeekWciScore"
                label="上周微指平均"
                sortable="custom"
                width="180"
              >
              </el-table-column>
              <el-table-column
                prop="lastWeekTkScore"
                label="上周抖指平均"
                sortable="custom"
                width="180"
              ></el-table-column>
              <el-table-column label="数据" width="80">
                <template slot-scope="{ row }">
                  <span class="icon" @click.stop="OpenKeywordChart(row)">
                    <svg
                      t="1763434425676"
                      class="icon"
                      viewBox="0 0 1024 1024"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      p-id="4712"
                      width="32"
                      height="32"
                    >
                      <path
                        d="M85.504 938.688H1024V1024H0v-85.312h0.192V0h85.312v938.688zM128 723.328l212.736-271.552 303.424 155.52L990.912 256v632.64H128v-165.312z"
                        fill="#ffffff"
                        p-id="4713"
                      ></path>
                    </svg>
                  </span>
                </template>
              </el-table-column>
              <el-table-column label="申赎清单" width="80">
                <template slot-scope="{ row }">
                  <span class="icon" v-if="!row.etfName.includes('LOF')" @click.stop="OpenPcfPage(row)">
                    <i class="el-icon-document" style="font-size: 20px;color: #ffffff;"></i>
                  </span>
                </template>
              </el-table-column>
              <el-table-column prop="createTime" label="创建时间" width="220">
              </el-table-column>
              <el-table-column prop="lastUpdateTime" label="最后更新时间" width="220">
              </el-table-column>
              <el-table-column prop="date" label="操作" width="280" v-if="isAdmin">
                <template slot-scope="{ row }">
                  <!-- <el-button
                    type="primary"
                    round
                    size="small"
                    icon="el-icon-edit"
                    style="margin-right: 5px"
                    @click.stop="EditClick(row)"
                    >编辑</el-button
                  > -->

                  <el-button
                    type="warning"
                    round
                    size="small"
                    icon="el-icon-share"
                    style="margin-right: 5px"
                    @click.stop="GrabSingle(row)"
                    >抓取</el-button
                  >
                  <!-- 
                  <el-button
                    type="danger"
                    round
                    size="small"
                    icon="el-icon-delete"
                    style="margin-right: 5px"
                    @click.stop="DelClick(row)"
                    >删除</el-button
                  > -->
                </template>
              </el-table-column>
            </el-table>

            <div class="PageCom">
              <el-pagination
                background
                :current-page="Page.index"
                :page-sizes="Page.sizes"
                :page-size="Page.size"
                :total="Page.total"
                layout="sizes, total, prev, pager, next"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
              />
            </div>
          </a-col>
        </a-row>
      </template>
    </a-card>
  </div>
</template>

<script>
import store from "@/store";
import { getEtfList } from "@/api/etf";
import { grabEtfInfo, delAllEtfTask } from "@/api/grab";
export default {
  data() {
    return {
      Query: {
        skey: "",
        rderType: 0,
      },
      tableData: [],
      Page: {
        index: 1,
        size: 10,
        sizes: [10, 50, 100, 200, 500, 1000],
        total: 0,
      },
      isAdmin: store.getters.roles.includes("admin"),

    };
  },
  created() {
    this.GetTableData();

    // if (this.isAdmin) {
    //   this.columns.push({
    //     title: "操作",
    //     key: "editBtn",
    //     scopedSlots: { customRender: "editBtn" },
    //   });
    // }
  },
  methods: {
    handleSizeChange(val) {
      this.Page.size = val;
      this.GetTableData(this.Query);
    },
    handleCurrentChange(val) {
      this.Page.index = val;
      this.GetTableData(this.Query);
    },
    GetTableData() {
      getEtfList(this.Query.skey, this.Page.index, this.Page.size, this.Query.orderType).then(
        (res) => {
          if (res.code == 0) {
            this.tableData = res.data.list;
            this.Page.total = res.data.total;
          }
        }
      );
    },
    sortChange({column, prop, order}) {
      if (prop == "lastWeekWciScore") {
        if (order == "ascending") {
          this.Page.index = 1;
          this.Query.orderType = 4;
          this.GetTableData();
        } else if (order == "descending") {
          this.Page.index = 1;
          this.Query.orderType = 1;
          this.GetTableData();
        } else {
          ///null   按照id倒序排列
          this.Page.index = 1;
          this.Query.orderType = 0;
          this.GetTableData();
        }
      }
      if (prop == "lastWeekTkScore") {
        if (order == "ascending") {
          this.Page.index = 1;
          this.Query.orderType = 5;
          this.GetTableData();
        } else if (order == "descending") {
          this.Page.index = 1;
          this.Query.orderType = 2;
          this.GetTableData();
        } else {
          ///null   按照id倒序排列
          this.Page.index = 1;
          this.Query.orderType = 0;
          this.GetTableData();
        }
      }
    },
    GrabAllKeys() {
      grabEtfInfo([]).then((res) => {
        if (res.code == 0) {
          this.$message({
            message: res.msg,
            type: "success",
          });
        }
      });
    },
    DelAllKeys() {
      delAllEtfTask().then((res) => {
        if (res.code == 0) {
          this.$message({
            message: res.msg,
            type: "success",
          });
        }
      });
    },
    GrabSingle(row) {
      grabEtfInfo([row.id]).then((res) => {
        if (res.code == 0) {
          this.$message({
            message: res.msg,
            type: "success",
          });
        }
      });
    },
    OpenKeywordChart(row) {
      try {
        // 直接构建完整URL，不依赖Vue Router的resolve方法
        const baseUrl = window.location.origin + window.location.pathname;
        const queryString = `?id=${row.keyId}`;
        const fullUrl = baseUrl + "#/etf_keyword-chart" + queryString;

        console.log("直接构建的完整URL:", fullUrl);

        // 添加防缓存参数
        const timestamp = new Date().getTime();
        const urlWithTimestamp =
          fullUrl + (fullUrl.includes("?") ? "&" : "?") + `t=${timestamp}`;

        const newWindow = window.open(urlWithTimestamp, "_blank");

        if (newWindow === null || typeof newWindow === "undefined") {
          console.warn("新窗口可能被浏览器阻止，尝试使用备选方案");
          window.location.href = urlWithTimestamp;
        }
      } catch (error) {
        console.error("跳转错误:", error);
        this.$router.push({
          path: "/etf_keyword-chart",
          query: { id: row.keyId },
        });
      }
    },
    OpenPcfPage(row){
      try {
        // 直接构建完整URL，不依赖Vue Router的resolve方法
        const baseUrl = window.location.origin + window.location.pathname;
        const queryString = `?id=${row.id}`;
        const fullUrl = baseUrl + "#/etf_pcf-chart" + queryString;

        console.log("直接构建的完整URL:", fullUrl);

        // 添加防缓存参数
        const timestamp = new Date().getTime();
        const urlWithTimestamp =
          fullUrl + (fullUrl.includes("?") ? "&" : "?") + `t=${timestamp}`;

        const newWindow = window.open(urlWithTimestamp, "_blank");

        if (newWindow === null || typeof newWindow === "undefined") {
          console.warn("新窗口可能被浏览器阻止，尝试使用备选方案");
          window.location.href = urlWithTimestamp;
        }
      } catch (error) {
        console.error("跳转错误:", error);
        this.$router.push({
          path: "/etf_pcf-chart",
          query: { id: row.id },
        });
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.icon {
  display: inline-flex;
  width: 32px;
  height: 32px;
  background-color: #1296db;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.12);
  border-radius: 6px;
  justify-content: center;
  align-items: center;
  margin: 7px;
  vertical-align: middle;
  cursor: pointer;
}
</style>